import React from "react";
import { connect } from "react-redux";
import { normalizeMoney, normalizeNumber, formatDate } from "../utility";
import { formValueSelector, reduxForm, Field, reset, change } from "redux-form";
import { MaterialTextField } from "./MaterialInput";
import transactionForm from "./TransactionForm";
import TransactionTable from "./TransactionTable";
import * as agent from "../agent";
import { MESSAGE_SENDED } from "../constants/actionTypes";
import { Dates, Transaction } from "../constants/enums";
import { generateCreditPayment } from "../businessLogic";
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InfoInput from "./InfoInput";
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { FormattedDate, FormattedNumber } from "react-intl";

const aliases = {"CREDIT": Transaction.OperationProlongationAliases, "DEBIT": Transaction.OperationRepayAliases};

const TransactionForm = connect(
    (state, props) => {
        const { credit, operations, totalPayment } = props;
        const { type, side } = credit;
        const prolongationOperation = operations.find(o => o.alias === (aliases[side])[type]) || {};
        const { mustHaveCredit, mustHaveDepartment } = prolongationOperation;
        return {
            mustHaveCredit,
            mustHaveDepartment,
            initialValues: {
                manager: state.common.user.id,
                paymentDate: formatDate(new Date()),
                operation: prolongationOperation._id,
                sum: normalizeMoney(totalPayment),
                vat: 0
            },
        };
    }
)(reduxForm({ form: "transaction-form", enableReinitialize: true })(transactionForm));

class prolongateCredit extends React.Component {

    state = {
        showingModal: false,
        transactions: [],
        managersLoaded: false,
        managers: [],
        counterparties: [],
        counterpartiesLoaded: false,
        accounts: [],
        accountsLoaded: false,
        operations: [],
        operationsLoaded: false,
    };

    componentWillMount = () => {
        const { isJuridicalPerson } = this.props;
        agent.User.managers(isJuridicalPerson)
            .then(res => this.setState({ managersLoaded: true, managers: res.managers }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Counterparty.getAll()
            .then(res => this.setState({ counterpartiesLoaded: true, counterparties: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Account.getAll()
            .then(res => this.setState({ accountsLoaded: true, accounts: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
        agent.Operation.getAll()
            .then(res => this.setState({ operationsLoaded: true, operations: res }))
            .catch(e => this.props.dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }
    handleClick = (e) => {
        e.preventDefault();
        this.setState({ showingModal: true})
    }
    handleClose = () => this.setState({ showingModal: false})
    changeDays = () => {
        const { changeFieldValue, totalPayment } = this.props;
        changeFieldValue("payment", totalPayment);
    }
    addTransaction = (data) => {
        const { transactions, operations } = this.state;
        const { totalPayment, dispatch, credit } = this.props;
        const { type, side } = credit;
        const updTransactions = transactions.concat(data);
        this.setState({ transactions: updTransactions });

        const prolongationOperation = operations.find(o => o.alias === (aliases[side])[type]) || {};

        const prolongationTSum = updTransactions.reduce((p, n) => p + +(n.operation === prolongationOperation._id ? n.sum.replace(/\s/g,``) : 0), 0);

        const nextSum = Math.max(totalPayment - prolongationTSum, 0);
        dispatch(change("transaction-form", "sum", normalizeMoney(nextSum)));
    }
    deleteTransaction = (index) => {
        const { transactions } = this.state;
        this.setState({ transactions: transactions.filter((_, i) => i !== index) })
    }
    onPaymentSubmit = (creditId, data, transactions) => {
        const { credit, updateCredit, dispatch } = this.props;
        const { side } = credit;
        agent.Credit.prolongate(creditId, data, transactions)
            .then(res => {
                dispatch({ type: MESSAGE_SENDED, payload: { text: `Проценты успешно ${{"DEBIT": "выплачены", "CREDIT": "приняты"}[side]}`, type: "success" } })
                dispatch(reset("credit-prolongate-form"))
                updateCredit(res);
                this.setState({ transactions: [] });
            })
            .catch(e => dispatch({ type: MESSAGE_SENDED, payload: { text: e.message, type: "error" } }));
    }

    render() {
        const { isAdmin,
                credit,
                totalPayment,
                inputDays,
                usedDays,
                periods,
                handleSubmit } = this.props;
        const { type, side, sum, rate, duration, _id, prolongationDate } = credit;

        const { showingModal,
                transactions,
                managers,
                managersLoaded,
                counterparties,
                counterpartiesLoaded,
                accounts,
                accountsLoaded,
                operations,
                operationsLoaded } = this.state;

        const prolongationOperation = operations.find(o => o.alias === (aliases[side])[type]) || {};
        const prolongationTransactions = transactions.filter(t => t.operation === prolongationOperation._id);
        const prolongationTSum = prolongationTransactions.reduce((p, n) => p + +n.sum.replace(/\s/g,``), 0);

        const allowedOperations = [(aliases[side])[type]]
        const submitEnabled = totalPayment === prolongationTSum;

        const prepareData = data => Object.assign(data, {
            totalPayment,
            prolongationDays:  inputDays
        });

        const processTransactions = () => transactions.map(t => {
            const fOperation = operations.find(o => o._id === t.operation) || {};
            return Object.assign(
                {...t},
                {sum: {"DEBIT": 1, "CREDIT": -1}[fOperation.side] * Number(t.sum.replace(/\s/g,``))},
            );
        });

        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <Grid container spacing={16}>
                    <Grid item className="common-column">
                        <form className="common-form" autoComplete="off">
                            <InfoInput label="Сумма займа"
                                       endAdornment="₽"
                                       placeholder={normalizeMoney(sum)} />
                            <InfoInput label="Процентная ставка"
                                       endAdornment="%"
                                       placeholder={rate} />
                            <InfoInput label="Срок займа"
                                       endAdornment="дн."
                                       placeholder={duration} />
                            <InfoInput label={"Оплачен по"}
                                       placeholder={formatDate(new Date(prolongationDate))} />
                            <InfoInput label="Дней пользования"
                                       placeholder={usedDays} />
                            <Field component={MaterialTextField}
                                   name="days"
                                   normalize={normalizeNumber}
                                   label="Оплатить дней" />
                           <InfoInput label="К оплате"
                                      placeholder={totalPayment} />
                           <Button onClick={this.handleClick}
                                   type="submit"
                                   color="primary"
                                   style={{ height: 49 }}
                                   fullWidth
                                   size="large"
                                   variant="contained">К транзакциям</Button>
                           <Dialog maxWidth={false} open={showingModal} onClose={this.handleClose}>
                               <Paper className="common-paper">
                                   <Grid container justify="center" spacing={16}>
                                       <Grid item className="common-column">
                                           <TransactionForm allowedOperations={allowedOperations}
                                                            addTransaction={this.addTransaction}
                                                            isAdmin={isAdmin}
                                                            creditMode={true}
                                                            managersLoaded={managersLoaded}
                                                            managers={managers}
                                                            accounts={accounts}
                                                            accountsLoaded={accountsLoaded}
                                                            counterparties={counterparties}
                                                            counterpartiesLoaded={counterpartiesLoaded}
                                                            operations={operations}
                                                            operationsLoaded={operationsLoaded}
                                                            credit={credit}
                                                            totalPayment={totalPayment} />
                                       </Grid>
                                       <Grid item className="maxwide-column">
                                           { transactions.length > 0 ?
                                              <TransactionTable transactions={transactions}
                                                                accounts={accounts}
                                                                counterparties={counterparties}
                                                                operations={operations}
                                                                onTransactionDelete={this.deleteTransaction} />
                                              :
                                              <Typography>Необходимо добавить транзакцию</Typography>
                                          }
                                       </Grid>
                                   </Grid>
                                   <Grid container spacing={16}>
                                       <Grid item className="common-column">
                                           <Button type="submit"
                                                   onClick={ handleSubmit(data => {
                                                       this.onPaymentSubmit(_id, prepareData(data), processTransactions(transactions));
                                                       this.handleClose(); })
                                                   }
                                                   fullWidth
                                                   disabled={!submitEnabled}
                                                   color="primary"
                                                   size="large"
                                                   variant="contained" >{{"CREDIT": "Принять", "DEBIT": "Выплатить"}[side]} проценты</Button>
                                       </Grid>
                                       <Grid item className="maxwide-column">
                                           {!submitEnabled && <Typography>Необходимо провести одну или несколько транзакций {{"CREDIT": "приема", "DEBIT": "выплаты"}[side]} процентов на указанную сумму {normalizeMoney(totalPayment)} ₽</Typography>}
                                           <Typography>Вы добавили {prolongationTransactions.length} транзакций на сумму {normalizeMoney(prolongationTSum)} ₽</Typography>
                                           {prolongationTSum > totalPayment && <Typography style={{ color: "red" }}>Сумма транзакций превышает требуемую сумму платежа на {normalizeMoney(prolongationTSum - totalPayment)} ₽. Удалите одну или несколько транзакций</Typography>}
                                           {prolongationTSum < totalPayment && <Typography style={{ color: "red" }}>Требуемая сумма платежа превышает сумму транзакций на {normalizeMoney(totalPayment - prolongationTSum)} ₽. Добавьте одну или несколько транзакций</Typography>}
                                           <Typography>Чтобы изменить требуемую сумму платежа закройте диалоговое окно</Typography>
                                       </Grid>
                                   </Grid>
                               </Paper>
                           </Dialog>
                        </form>
                    </Grid>
                    <Grid item className="ultrawide-column">
                        {usedDays > 0 ?
                            <Table padding="checkbox">
                                <TableHead >
                                    <TableRow >
                                        <TableCell>Начало периода</TableCell>
                                        <TableCell>Конец периода</TableCell>
                                        <TableCell>Дней пользования</TableCell>
                                        <TableCell>Сумма займа в периоде</TableCell>
                                        <TableCell>Ежедневный платеж</TableCell>
                                        <TableCell>Платеж за период</TableCell>
                                    </TableRow >
                                </TableHead >
                                <TableBody >
                                {periods.map(({ startDate, endDate, numDays, sum, sumPerDay, totalSum }, i) => (
                                    <TableRow key={i}>
                                        <TableCell>
                                            <FormattedDate value={startDate}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedDate value={endDate}
                                                           day="numeric"
                                                           month="numeric"
                                                           year="numeric" />
                                        </TableCell>
                                        <TableCell>
                                            {numDays}
                                        </TableCell>
                                        <TableCell>
                                            <FormattedNumber value={sum}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={2} />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedNumber value={sumPerDay}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={2} />
                                        </TableCell>
                                        <TableCell>
                                            <FormattedNumber value={totalSum}
                                                             style={`currency`}
                                                             currency="RUB"
                                                             minimumFractionDigits={2} />
                                        </TableCell>
                                    </TableRow >
                                ))}
                                <TableRow>
                                    <TableCell colSpan={5}>
                                        Итого:
                                    </TableCell>
                                    <TableCell>
                                        <FormattedNumber value={totalPayment}
                                                         style={`currency`}
                                                         currency="RUB"
                                                         minimumFractionDigits={2} />
                                    </TableCell>
                                </TableRow >
                                </TableBody >
                            </Table>
                            :
                            <Typography>Укажите количество оплачиваеых дней</Typography>
                        }
                    </Grid>
                </Grid>
            </Paper>
        )
    }
}

const ProlongateCredit = connect(
    (state, props) => {
        const { credit } = props;
        const { prolongationDate, sum, rate, sumLog } = credit;
        const inputDays = Number(`${formValueSelector("credit-prolongate-form")(state, "days")}`);

        const pDate = new Date(prolongationDate);
        const lastPaymentDay = new Date(+pDate + inputDays * Dates._1Day);

        const usedDays = Math.floor((new Date() - pDate) / Dates._1Day);

        const periods = generateCreditPayment({ sumLog, sum, pDate, rate, lastPaymentDay });
        const totalPayment = Math.round(periods.reduce((a, b) => a + b.totalSum, 0));

        return {
            isAdmin: state.common.user.permissions.includes("forms-full-access"),
            usedDays,
            inputDays,
            totalPayment,
            periods,
            initialValues: {
                days: Math.floor((new Date() - pDate) / Dates._1Day)
            },
        };
    },
    dispatch => ({
        changeFieldValue: (field, value) =>
            dispatch(change("credit-prolongate-form", field, value))
    })
)(reduxForm({
    form: "credit-prolongate-form"
})(prolongateCredit));

export default ProlongateCredit;



// WEBPACK FOOTER //
// ./src/components/ProlongateCredit.js